import React from "react";
import { useState } from "react";
import {
  Button,
  Card,
  Collapse,
  Divider,
  Input,
  Modal,
  Select,
  message,
  Tooltip,
  Spin
} from "antd";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { InfoCircleOutlined } from "@ant-design/icons";
import {
  GetAutoCrawlStatus,
  Get_ReConsolidation_Client_Header_Data,
} from "../../redux/TimeCardsRedux/TimeCardsActions";
import HeaderMapping from "./HeaderMapping";
import {
  GetSingleClientCreds,
  UpdateClientCredential,
} from "../../Repository/ClientCredentialsRepository";
import { SuccessMessage } from "../../Utils/Utils";

const InvalidClientsCard = () => {
  //State Variables
  const [isModalVisibleFlag, setIsModalVisibleFlag] = useState(false);
  const [ClientData, setClientData] = useState({});
  const [ModifiedClientData, setModifiedClientData] = useState({});
  const [SelectedVms, setSelectedVms] = useState("");
  const [HeaderModalFlag, setHeaderModalFlag] = useState(false);
  const [RcClient, setRcClient] = useState("");
  const [IsCrawling, setIsCrawling] = useState(false);
  // const [ClientHeaderData, setClientHeaderData] = useState({});

  const [messageApi, contextHolder] = message.useMessage();
  const jwtToken = Cookies.get("jwt_token");
  const userLogin = Cookies.get("UserLogin");

  const dispatch = useDispatch();

  const InvalidFailedClients = useSelector(
    (state) => state.timecardsReducer.invalidClients
  );

  const FailedClients = useSelector(
    (state) => state.timecardsReducer.failedClients
  );

  //Get ReConsolidation Clients List
  const ReConsolidation_Clients = useSelector(
    (state) => state.rcClientsReducer.ReConsolidationClients
  );

  //Fetching Invalid Client Old Credentials
  const getInvalidClientData = async (InvalidClient) => {
    const Response = await GetSingleClientCreds({
      vms: InvalidClient.Vms_Name,
      client: InvalidClient.Client_Name,
    });
    if (Response != null) {
      setClientData(
        Object.entries(JSON.parse(Response)).map((data) => ({
          id: data[0],
          value: data[1],
        }))
      );
      setModifiedClientData(JSON.parse(Response));
      setSelectedVms(InvalidClient.Vms_Name);
      setIsModalVisibleFlag(true);
    }
  };

  //Run the Updated Client API
  const RunUpdatedClient = (Vms_Name) => {
    let Frequency = "Bi-Weekly";
    let User_Id = InvalidFailedClients[0].User_Id;
    let Client = [];
    Client.push(ModifiedClientData.Client_Name);

    //Loader Symbol
    setIsCrawling(true);

    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}Home/DownloadForSelectedClients?VMS=` +
        Vms_Name +
        `&frequency=` +
        Frequency +
        `&userLogin=` +
        User_Id,
        JSON.stringify(Client),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      )
      .then((response) => {
        //Loader Symbol
        setIsCrawling(false);
        dispatch(GetAutoCrawlStatus());
      });
  };

  //Updating Client Credentials
  const onUpdateClient = async (Vms_Name) => {
    setIsModalVisibleFlag(false);
    const Response = await UpdateClientCredential(ModifiedClientData);
    if (Response != null) {
      SuccessMessage(Response.message);
      RunUpdatedClient(Vms_Name);
    }
  };

  const onCancelAutoCrawlModal = () => {
    setIsModalVisibleFlag(false);
  };

  //OnDataChange
  const altered = {};
  const updatedData = (newData) => {
    newData.map((item) => (altered[item.id] = item.value));
    return altered;
  };

  const onChangeInput = (event, id) => {
    const {
      target: { value },
    } = event;

    const newData = ClientData.map((data) => {
      if (data.id === id) {
        data.value = value;
      }
      return data;
    });
    setClientData(newData); //set updated data for form
    setModifiedClientData(updatedData(newData)); //set data for PUT operation
  };

  //Re Concolidation Section
  const GetClientHeaders = async (index) => {
    const ClientName = ReConsolidation_Clients[index].Client;
    dispatch(Get_ReConsolidation_Client_Header_Data(ClientName));
    setHeaderModalFlag(true);
    setRcClient(ClientName);
  };

  return (
    <>
      {contextHolder}
      {/* Cards-display */}
      <div className="cards-display">
        {InvalidFailedClients &&
          InvalidFailedClients.map((item, index) => {
            return (
              <>
                <div className="failed-clients-container">
                  <Card
                    key={index}
                    className="card-class"
                    onClick={() => getInvalidClientData(item)}
                  >
                    <div className="vms-client">
                      <div style={{ color: "#003A8C" }}>{item.Client_Name}</div>
                      <Divider
                        type="vertical"
                        style={{
                          borderColor: "#003A8C",
                          borderLeftWidth: "2px",
                        }}
                      ></Divider>
                      <div
                        style={{ color: "rgba(0,58,140,1.0", fontSize: "12px" }}
                      >
                        {item.Vms_Name}
                      </div>
                    </div>
                    <div className="status">{item.Error_Message}
                      {
                        IsCrawling && ModifiedClientData && ModifiedClientData.Client_Name === item.Client_Name? <Spin key={index} size="medium" style={{ marginLeft: "10px" }}>
                        </Spin> : <></>
                      }
                    </div>
                  </Card>
                </div>

                <Modal
                  closable={false}
                  open={isModalVisibleFlag}
                  okText="Update & Run"
                  onOk={() => onUpdateClient(SelectedVms)}
                  onCancel={onCancelAutoCrawlModal}
                  bodyStyle={{ height: "170px", padding: "20px" }}
                >
                  <div>
                    {isModalVisibleFlag == true && ClientData.length === 0 ? (
                      "Client Not Found/ Select Client Properly"
                    ) : (
                      <form onSubmit={onUpdateClient}>
                        <h2>
                          {ClientData.length > 0
                            ? ClientData.find(
                              (data) => data.id == "Client_Name"
                            ).value
                            : ""}
                          , {SelectedVms}
                        </h2>
                        {isModalVisibleFlag == true &&
                          ClientData.filter(
                            (clientObject) =>
                              clientObject.id == "portal_username" ||
                              clientObject.id == "portal_password"
                          ).map((ClientCreds) => {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  marginBottom: "10px",
                                }}
                              >
                                <label style={{ marginRight: "10px" }}>
                                  {ClientCreds.id}:
                                </label>
                                {ClientCreds.id === "portal_password" ? (
                                  <Input.Password
                                    id={ClientCreds.id}
                                    key={ClientCreds.id}
                                    value={ClientCreds.value}
                                    onChange={(event) =>
                                      onChangeInput(event, ClientCreds.id)
                                    }
                                  />
                                ) : (
                                  <Input
                                    id={ClientCreds.id}
                                    key={ClientCreds.id}
                                    value={ClientCreds.value}
                                    onChange={(event) =>
                                      onChangeInput(event, ClientCreds.id)
                                    }
                                  />
                                )}
                              </div>
                            );
                          })}
                      </form>
                    )}
                  </div>
                </Modal>
              </>
            );
          })}

        {ReConsolidation_Clients &&
          ReConsolidation_Clients.map((client, index) => {
            return (
              <>
                <div key={index} className="failed-clients-container">
                  <Card
                    className="card-class"
                    onClick={() => GetClientHeaders(index)}
                  >
                    <div className="vms-client">
                      <div style={{ color: "#003A8C" }}>{client.Client}</div>
                      <Divider
                        type="vertical"
                        style={{
                          borderColor: "#003A8C",
                          borderLeftWidth: "2px",
                        }}
                      ></Divider>
                      <div
                        style={{ color: "rgba(0,58,140,1.0", fontSize: "12px" }}
                      >
                        {client.VMS}
                      </div>
                    </div>
                    <div className="reconsolidation-info">
                      <div className="status">Re-Consolidation</div>
                      <Tooltip
                        placement="bottomRight"
                        color="#5e9cff"
                        title="Click on the Card to Update Mis-Mapped Headers and Re-Consolidate Client"
                      >
                        <InfoCircleOutlined className="info-icon" />
                      </Tooltip>
                    </div>
                  </Card>
                </div>
              </>
            );
          })}
      </div>
      <HeaderMapping
        HeaderModalFlag={HeaderModalFlag}
        setHeaderModalFlag={setHeaderModalFlag}
        RcClient={RcClient}
      />
    </>
  );
};

export default InvalidClientsCard;
